import gql from 'graphql-tag';

const edges = `
      edges {
        cursor
        node {
          id
          title
          activateDate
          class
          state
          component
          message
          actionMessage
          outcomeGoal
          emergencyLevel
          user {
            subjectId
            patient {
              patientId
            }
          }
        }
      }`;

export const getAlerts = gql`query getAlerts(
    $functions: [RelayalertReminderFunction],
    $conditions: RelayalertReminderCondition,
    $orders: [RelayalertReminderOrder!],
    $limit: Int,
    $offset: Int,
  ) {
    alerts(
      functions: $functions
      orders: $orders
      conditions: $conditions
      limit: $limit
      offset: $offset
      meta: { count: true }
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      count
      ${edges}
    }
  }`;

export const getRecentAlerts = gql`query getRecentAlerts($patientId: String!)
  {
    alerts(
      functions: { function: patientId, parameters: [$patientId] }
      orders: [{ field: activateDate, direction: desc }]
      conditions: {gate : and, inputs : [
            { field: state, operator: in, parameters:  ["active", "handled"] }
            { function : sinceLastSDMEncounterEnd }
      ]}
    ) {
      ${edges}
    }
  }`;

export const handleOrReactivateAlert = function(isReactivate = false) {
      const mutationAction = isReactivate ? 'reactivateAlert' : 'handleAlert';

      return gql`mutation ${mutationAction}($alertId: String!)
        {
          ${mutationAction}(id: $alertId) {
            id
            class
            state
            title
            activateDate
            component
            message
            actionMessage
            outcomeGoal
            emergencyLevel
            user {
              subjectId
              patient {
                patientId
              }
            }
          }
        }`
}

export const sendReminderToPatient = gql`mutation sendReminderToPatient(
    $patientId: Int!,
    $reminderType: String!,
    $force: Boolean!,
    $forceNotify: Boolean!,
    $parameters: [ParameterInput!]!
) {
    checkReminder(
        patientId : $patientId
        handlerType : $reminderType
        force : $force
        forceNotify : $forceNotify
        parameters : $parameters
    ){
        id
        type
        handlerType
        message
        parameters{
            key
            value
        }
    }
}`
